import { declareVueComponent } from '/vodalys/vvuejs/vueRegister.mjs'

import TroubleshootingBandwith2 from './TroubleshootingBandwith2.vue'
declareVueComponent('troubleshootingBandwith2', TroubleshootingBandwith2);

import TroubleshootingBandwith2Download from './TroubleshootingBandwith2Download.vue'
declareVueComponent('troubleshootingBandwith2Download', TroubleshootingBandwith2Download);
